module.exports = __webpack_public_path__ + "img/tracee_s.2d6aada3.png";